import NumberInput from "./Number";

export default NumberInput;
